import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import i18n from 'i18next';
import { Field, reduxForm } from 'redux-form';

import Button from 'src/components/buttons/button';
import ValidatedTextInput from 'src/components/inputs/validatedTextInput';
import TextInput from 'src/components/inputs/textInput';
import { loginWithSocial } from 'src/modules/shared/auth/actions';
import { required, minLength } from 'src/utils/validators';

class LinkAccountSocialSignupBox extends React.Component {
  static propTypes = {
    authdata: PropTypes.object.isRequired,
  }

  onSubmit= async ({ password }) => {
    const { authdata, loginWithSocial, onSuccess } = this.props;
    await loginWithSocial({...authdata, password}, !!authdata.googleUserId ? 'Google' : 'Facebook');
    onSuccess();
  }

  render() {
    const { submitting, authdata } = this.props;
    return <div className="signup-box__terms">
      <h3 className="signup-box__questions__title">
        {i18n.t('Just this once...')}
      </h3>
      <p>
        {i18n.t('You already have a HealthUnlocked account, but we need to make sure it\'s you.')}
      </p>
      <p>
        {i18n.t('Please add your HealthUnlocked password to login with one click from now on.')}
      </p>
      <form role="form" onSubmit={this.props.handleSubmit(this.onSubmit)}>
        <div className="signup-box__link-form">
          <TextInput
            disabled={true}
            icon="email"
            name="email"
            type="text"
            value={authdata.email}
          />
          <Field
            name="password"
            placeholder={i18n.t('Password')}
            type="password"
            icon="lock"
            validate={[
              required('Password is required'),
              minLength(6, 'Passwords must be at least 6 characters long'),
            ]}
            component={ValidatedTextInput}
          />
        </div>
        <Button text={i18n.t('Log in with email')}
          size="lg"
          onClick={this.props.handleSubmit(this.onSubmit)}
          disabled={submitting}
          fullWidth={true}
        />
      </form>
    </div>;
  }
}

const LinkAccountSocialSignupForm = reduxForm({
  form: 'linksocial',
})(LinkAccountSocialSignupBox);

export default connect(null, { loginWithSocial })(LinkAccountSocialSignupForm);



// WEBPACK FOOTER //
// ./src/modules/shared/modal/components/signup/linkLoginToSocial.js